import isRuntimeRender from './is-runtime-render';

export default {
  isRuntimeRender,
};
